import React from 'react';
import ReactDOM from 'react-dom';
import AppPage from './components/pages/AppPage';
import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';
import bootstrapEnsighten from './scripts/ensighten';
import { BRAND_NAMES } from './utils/constants/commonConstants';
import {
  asyncWithLDProvider,
  basicLogger,
} from 'launchdarkly-react-client-sdk';
import injectCSP from './scripts/csp';

const envConfig = window.envConfig;
const store = configureStore(envConfig.sessionStorageKey);

bootstrapEnsighten(envConfig.ensighten);
envConfig.appEnv !== 'local' && injectCSP();

const getBrand = () => {
  const hostname = window.location.hostname.toLowerCase();
  for (const [brand, brandName] of Object.entries(BRAND_NAMES)) {
    if (hostname.includes(brandName.toLowerCase())) {
      return brand; //match found
    }
  }
};

(async () => {
  let brand = getBrand();
  const LDProvider = await asyncWithLDProvider({
    clientSideID: envConfig.launchDarklyClientSideID,
    user: {
      //ex - user.custom.brand == "BINGLE" -> serve true
      key: 'anonymous',
      anonymous: true,
      custom: {
        brand,
      },
    },
    options: {
      logger: basicLogger({ level: 'none' }),
    },
  });

  ReactDOM.render(
    <Provider store={store}>
      <LDProvider>
        <AppPage config={envConfig} />
      </LDProvider>
    </Provider>,
    document.getElementById('react-container'),
  );
})();
